import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-score-rating-slider',
    templateUrl: './score-rating-slider.component.html',
    styleUrls: ['./score-rating-slider.component.scss'],
    standalone: false
})
export class ScoreRatingSliderComponent implements OnInit {
  @Input() musaffaData: any;
  @Input() communityData: any;
  isTooltipBelow = false;

  ngAfterViewChecked() {
    this.adjustTooltipPositions();
  }
  get allCriteriaScoresZero(): boolean {
  //  console.log('allCriteriaScoresZero: Checking communityData:', this.communityData);
   if (!this.communityData) {
      // console.log('allCriteriaScoresZero: communityData is null or undefined, returning true');
      return true;
   }
   const allZero =
      this.communityData.community_impact_and_reputation === 0 &&
      this.communityData.human_rights_and_labor_practices === 0 &&
      this.communityData.product_and_sector_involvement === 0 &&
      this.communityData.environmental_responsibility === 0 &&
      this.communityData.ethical_governance === 0;
   return allZero;
}

  adjustTooltipPositions() {
    // Only adjust if both tooltips exist
    if (this.musaffaData?.iri_score && this.communityData?.iri_score) {
      const score1 = this.musaffaData.iri_score;
      const score2 = this.communityData.iri_score;

      // If scores are within 1 point of each other, move one tooltip below
      this.isTooltipBelow = Math.abs(score1 - score2) < 1;
    } else {
      this.isTooltipBelow = false;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  isPanelOpen = true; // initially true if activeIds is panel-0
  activePanel = 'panel-0'; // default open panel id

  onPanelChange(event: any) {
    this.isPanelOpen = event.nextState;
  }

getArrowPosition(score: number | string): string {
  const numericScore = typeof score === 'string' ? parseFloat(score) : score;

  if (numericScore <= 4.85) return '50%'; // static position

  const clampedScore = Math.min(numericScore, 5); // ensure max 5
  const progress = (clampedScore - 4.85) / (5 - 4.85); // 0 to 1
  const left = 50 + progress * (85 - 50); // 50% to 85%
  return `${left}%`;
}


}
